"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./TRCDialog.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
 * @deprecated since 10/29/2020
 * Will be removed soon
 */
var TRCDialog = /*#__PURE__*/function (_Component) {
  _inherits(TRCDialog, _Component);

  var _super = _createSuper(TRCDialog);

  function TRCDialog(props) {
    var _this;

    _classCallCheck(this, TRCDialog);

    _this = _super.call(this, props);
    console.warn("TRCDialog is a depricated component!");
    _this.lastShown = false;
    _this.state = {
      shown: false
    };
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TRCDialog, [{
    key: "title",
    get: function get() {
      return /*#__PURE__*/_react.default.createElement("h2", null, "Dialog title");
    }
  }, {
    key: "content",
    get: function get() {
      return /*#__PURE__*/_react.default.createElement("p", null, "Dialog Body");
    }
  }, {
    key: "addClassName",
    get: function get() {
      return '';
    }
  }, {
    key: "dismissUrl",
    get: function get() {
      return false;
    }
  }, {
    key: "allowClose",
    get: function get() {
      return true;
    }
  }, {
    key: "dialogActions",
    get: function get() {
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var that = this;
      setTimeout(function () {
        that.setState({
          shown: true
        });
      }, 100);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {}
  }, {
    key: "willShowDialog",
    value: function willShowDialog() {}
  }, {
    key: "willCloseDialog",
    value: function willCloseDialog() {// track dialog closes
    }
  }, {
    key: "didCloseDialog",
    value: function didCloseDialog() {}
  }, {
    key: "enableLock",
    value: function enableLock() {}
  }, {
    key: "disableLock",
    value: function disableLock() {}
  }, {
    key: "close",
    value: function close(e) {
      var _this2 = this;

      if (e) {
        e.preventDefault();
        this.willCloseDialog();
      }

      this.setState({
        shown: false
      });
      setTimeout(function () {
        if (_this2.props.history && _this2.dismissUrl) {
          _this2.props.history.push(_this2.dismissUrl);
        } else if (_this2.props.history) {
          _this2.props.history.goBack();
        } //this.setState({ shown: true })


        _this2.didCloseDialog();
      }, 600);
    }
  }, {
    key: "render",
    value: function render() {
      var klass = "dialog-modal ".concat(this.addClassName);

      if (this.state.shown) {
        klass += ' show';
      } else {
        klass += ' hide';
      }

      if (this.state.shown !== this.lastShown) {
        this.lastShown = this.state.shown;
      }

      var closeHandle = this.close;

      if (!this.allowClose) {
        this.closeHandle = function (e) {
          e.preventDefault();
        };
      }

      var doneButton = '';

      if (this.allowClose) {
        doneButton = /*#__PURE__*/_react.default.createElement("a", {
          className: "dialog-title-btn",
          onClick: this.close,
          href: "#done"
        }, "Done");
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: klass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dialog-shade",
        onClick: closeHandle
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "dialog"
      }, this.title && /*#__PURE__*/_react.default.createElement("div", {
        className: "dialog-title"
      }, this.title, doneButton), !this.title && doneButton, /*#__PURE__*/_react.default.createElement("div", {
        className: "dialog-content"
      }, this.content), this.dialogActions));
    }
  }]);

  return TRCDialog;
}(_react.Component);

exports.default = TRCDialog;